import { routes as home } from '@/pages/home';
import { routes as dashboard } from '@/pages/dashboard';
import { routes as sobre } from '@/pages/sobre';
import { routes as mailing } from '@/pages/landing';
import { routes as pesquisa } from '@/pages/pesquisa';

export default [
    ...home,
    ...dashboard,
    ...sobre,
    ...mailing,
    ...pesquisa,
    {
        path: "/:pathMatch(.*)",
        name: "notFound",
        component: () => import(/* webpackChunkName: "not-found" */ "@/pages/NotFound"),
    },
];